// @ts-nocheck
import { createRef } from "react";
import { withRouter } from "react-router-dom";
import StatusDiv from "../../../../base/basicComponents/status/index";
import NormalSpin from "../../../../base/basicComponents/spin";
import ProcedureBlock from "../../../../base/basicComponents/procedureBlock";
import ProcedureFileSection from "../../../sections/procedureFileSections/procedureFileSection";
import SupportingFileSection from "../../../sections/supportingFileSections/supportingFileSection";
import ProcedureInfoSection from "../../../sections/procedureInfoSections/procedureInfoSection";
import TaskInformation from "../../../sections/taskInfoSections";
import ShareTask from "../../../sections/sharedTaskSections";
import ProcedureDetailService from "../../../../service/procedureFile/ProcedureDetailService";
import styles from "./style/index.module.scss";
import "./style/index.scss";
import { debounce } from "lodash";
import RoutingComponent from "../../../../base/common/RoutingComponent";
import { monitorPersistentRequests } from "../utils";
import { isExecutePendingAction } from "../../../../store/actions/procedureDetailPageActions";
import { disableInteraction, enableInteraction } from "utils";
import { bindUnloadUnlock } from "utils/lockUnload";

const procedureRef = createRef();
const supportingRef = createRef();
const procedureInfoRef = createRef();
class CreateProcedureDetail extends RoutingComponent {
  constructor(props: any) {
    super(props);
    this.state = {
      status: 0,
      isMounted: false,
      procedureFlientPathDisabled: false,
      taskInfoData: [],
      closable: false,
      taskInformationData: {},
      loading: false,
      hintMsg: "",
      timer: 0,
      isShareTaskEditToolTipOpen: false,
      uploadProcedureFileNum: 0,
      uploadSupportingFileNum: 0,
      procedureId: this.props.procedureId,
      procedureTaskId: this.props.procedureTaskId ?? this._getRoutingParam("ProcedureTaskId"),
      openSection: this.props.openSection ?? this._getRoutingParam("OpenSection"),
      procedureAccountId: null,
      isProcedureFileModalChange: false,
      isSupportingFileModalChange: false,
      isProcedureInfoModalChange: false,
      fileLoading: { currentNum: 0, allNum: 0 },
      procedureJbStatusId: null,
      sectionEditShow: {
        isShowProcedureFileEdit: false,
        isShowSupportingFileEdit: false,
        isShowProcedureInfoEdit: false,
        isShowShareTaskEdit: false,
      },
    };

    // @ts-ignore
    this.procedureFileNum = 0;
    // @ts-ignore
    this.supportingFileNum = 0;
    // @ts-ignore
    this.restoreTime = false;
    // @ts-ignore
    this.actionType = null;
  }

  setProcedureJbStatusId = (procedureJbStatusId: any) => {
    this.setState({
      procedureJbStatusId: procedureJbStatusId,
    });
  };

  handleProcedureFileUploadLoading = () => {
    // @ts-ignore
    if (this.state.uploadProcedureFileNum === this.procedureFileNum) {
      // @ts-ignore
      this.procedureFileNum = 0;
      this.setState({
        uploadProcedureFileNum: 0,
        loading: false,
      });
    }
  };

  setUploadProcedureFileNum = () => {
    this.setState({
      uploadProcedureFileNum: this.state.uploadProcedureFileNum + 1,
    });
  };

  setProcedureFileNum = () => {
    // @ts-ignore
    this.procedureFileNum += 1;
  };

  handleSupportingFileUploadLoading = () => {
    // @ts-ignore
    if (this.state.uploadSupportingFileNum === this.supportingFileNum) {
      // @ts-ignore
      this.supportingFileNum = 0;
      this.setState({
        uploadSupportingFileNum: 0,
        loading: false,
      });
    }
  };

  setUploadSupportingFileNum = () => {
    this.setState({
      uploadSupportingFileNum: this.state.uploadSupportingFileNum + 1,
    });
  };

  setSupportingFileNum = () => {
    // @ts-ignore
    this.supportingFileNum += 1;
  };

  _showLoading = () => {
    disableInteraction();
    this.setState({
      loading: true,
    });
  };

  _hideLoading = debounce(
    () => {
      void (async () => {
        await monitorPersistentRequests();
        const isExecute = isExecutePendingAction();
        if (isExecute) {
          setTimeout(this._hideLoading, 300);
          return;
        }
        await enableInteraction();
        this.setState({
          loading: false,
        });
      })();
    },
    300,
    {
      leading: true,
      trailing: false,
    }
  );

  _getTaskInfoSuccess = (result: any) => {
    const data = result;
    this.setState({
      taskInformationData: data,
      procedureAccountId: data.procedureAccountID,
    });
    this.getShowSectionEditPermission(data.procedureAccountID);
    this.initSection(data.procedureAccountID);
  };

  _getTaskInfoFailed = (result: any) => {
    console.log(result);
  };

  setStatus = (status: any) => {
    this.setState({
      isMounted: true,
      status: status,
    });
  };

  _procedureSaveSuccess = (result: any) => {
    this.setState({
      procedureId: result.procedureId,
      procedureFileStepId: result.procedureFileStepId,
      isMounted: true,
      loading: false,
    });
    this._alertSuccess("Save Successful");
    this.setStatus(result.procedureFolderStatus);
  };

  _procedureSubmitSuccess = (result: any) => {
    this.setState({
      isMounted: true,
      status: result.procedureFolderStatus,
      loading: false,
      procedureId: this.props.procedureId ? this.props.procedureId : result.procedureId,
    });
    this._alertSuccess("Submit Successful");
  };

  _supportingSaveSuccess = (result: any) => {
    this.setState({
      loading: false,
      procedureId: result.procedureId,
    });
  };

  _supportingSubmitSuccess = (result: any) => {
    this.setState({
      loading: false,
      procedureId: this.props.procedureId ? this.props.procedureId : result.procedureId,
    });
  };

  /* callback when call submit information api success */
  _procedureInfoSubmitSuccess = (response: any) => {
    this.setState({
      procedureId: this.props.procedureId ? this.props.procedureId : response.procedureId,
    });
  };

  _getPrimaryProcedureOwnerDDLSuccess = (result: any) => {
    // @ts-ignore
    procedureInfoRef.current.setPpoList(result);
  };

  _getPrimaryProcedureOwnerDDLFailed = () => {
    console.log("Get Primary Procedure Owner Failed");
  };

  setLock = (msg: any) => {
    this.setState({
      hintMsg: msg,
    });
  };

  getProcedureSectionError = () => {
    console.log("Get procedure section data error!");
  };

  getTaskInfo = () => {
    ProcedureDetailService.getTaskInfo(
      {
        isHistorical: false,
        procedureTaskId: this.state.procedureTaskId,
      },
      this._getTaskInfoSuccess,
      this._getTaskInfoFailed
    );
  };

  getPrimaryProcedureOwnerDDL = () => {
    ProcedureDetailService.getPrimaryProcedureOwnerDDL(
      this.state.procedureTaskId,
      this._getPrimaryProcedureOwnerDDLSuccess,
      this._getPrimaryProcedureOwnerDDLFailed
    );
  };

  getProcedureProcessStatus = () => {
    ProcedureDetailService.getProcedureProcessStatus(
      { procedureId: this.state.procedureId },
      (response: any) => this.setStatus(response.procedureProcessStatus),
      () => console.log("Get status error!")
    );
  };

  getShowSectionEditPermission = (procedureAccountId: any) => {
    const para = {
      procedureId: this.state.procedureId,
      procedureAccountId,
      procedureTaskId: this.state.procedureTaskId,
    };
    ProcedureDetailService.getShowEditPermission(
      para,
      (response: any) => this.setState({ sectionEditShow: response }),
      () => console.log("Get Show Section Edit Permission Failed!")
    );
  };

  pageEvent = () => {
    // @ts-ignore
    this.unbindUnloadUnlock = bindUnloadUnlock(
      // @ts-ignore
      () => this.actionType !== null,
      // @ts-ignore
      () => {
        ProcedureDetailService.releaseLockOnUnload({
          procedureId: this.state.procedureId,
          procedureSectionType: this.actionType,
        });
      }
    );
  };

  initSection = (procedureAccountId: any) => {
    // @ts-ignore
    procedureRef.current !== null && procedureRef.current.createFiles();
    // @ts-ignore
    supportingRef.current !== null && supportingRef.current.createFiles();
    // @ts-ignore
    procedureInfoRef.current !== null &&
      procedureInfoRef.current.createProcedureInfoData(null, procedureAccountId);
  };

  componentDidMount() {
    this.getTaskInfo();
    this.getPrimaryProcedureOwnerDDL();
    if (this.state.procedureId) {
      this.getProcedureProcessStatus();
    }
    this.pageEvent();
  }

  componentWillUnmount() {
    // @ts-ignore
    this.unbindUnloadUnlock?.();
  }

  componentDidUpdate(prevProps: any, prevState: any) {
    if (this.state.isProcedureFileModalChange !== prevState.isProcedureFileModalChange) {
      // @ts-ignore
      procedureRef.current.createFiles();
    } else if (this.state.isSupportingFileModalChange !== prevState.isSupportingFileModalChange) {
      // @ts-ignore
      supportingRef.current.createFiles();
    } else if (this.state.isProcedureInfoModalChange !== prevState.isProcedureInfoModalChange) {
      // @ts-ignore
      procedureInfoRef.current.createProcedureInfoData();
    }
  }

  handleUploadingFileNum = (uploadProcedureFileNum: any, uploadSupportingFileNum: any) => {
    if (uploadProcedureFileNum > 0) {
      return uploadProcedureFileNum;
    }

    return uploadSupportingFileNum > 0 ? uploadSupportingFileNum : 0;
  };

  handleUploadingFileList = (uploadProcedureFileNum: any, uploadSupportingFileNum: any) => {
    if (uploadProcedureFileNum > 0) {
      // @ts-ignore
      return procedureRef.current.getFileList();
    }

    // @ts-ignore
    return uploadSupportingFileNum > 0 ? supportingRef.current.getFileList() : [];
  };

  handleReturnShareTask = () => (
    // @ts-ignore
    <ShareTask
      actionType="ShareTask"
      isEditToolTipOpen={this.state.isShareTaskEditToolTipOpen}
      onBlur={() => (this as any).setScrollModalOpen(false)}
      procedureId={this.props.procedureId}
      procedureTaskId={this.props.procedureTaskId}
      showLoading={this._showLoading}
      hideLoading={this._hideLoading}
      setActionType={this.setActionType}
      isShowShareTaskEdit={this.state.sectionEditShow.isShowShareTaskEdit}
    />
  );

  checkShareTaskWhetherLock = (isLock: any, lockUser: any) => {
    if (isLock) {
      // @ts-ignore
      this.setScrollModalOpen(true);
      this.setState({
        isLocked: true,
        lockUser: lockUser,
      });
    } else {
      this.setState({
        isShareTaskEditToolTipOpen: false,
      });
    }
  };

  setActionType = (actionType: any) => {
    // @ts-ignore
    this.actionType = actionType;
  };

  setIsProcedureFileModalChange = () => {
    this.setState({
      isProcedureFileModalChange: true,
    });
  };

  setIsSupportingFileModalChange = () => {
    this.setState({
      isSupportingFileModalChange: true,
    });
  };

  setIsProcedureInfoModalChange = () => {
    this.setState({
      isProcedureInfoModalChange: true,
    });
  };

  /**
   * Change update attachment loading ui
   * @param {*} fileLoading
   */
  updateFileNumLoading = (fileLoading: any) => {
    this.setState({
      fileLoading: fileLoading,
      loading: fileLoading.allNum !== fileLoading.currentNum,
    });
  };

  render() {
    const {
      isMounted,
      status,
      taskInformationData,
      loading,
      uploadProcedureFileNum,
      uploadSupportingFileNum,
      hintMsg,
      procedureId,
      procedureTaskId,
      openSection,
      procedureAccountId,
      sectionEditShow,
    } = this.state;

    const { title, pageType, procedureFilesRef } = this.props;

    const isShowTable = procedureFilesRef !== undefined ? isMounted : true;

    const uploadingFileNum = this.handleUploadingFileNum(
      uploadProcedureFileNum,
      uploadSupportingFileNum
    );

    const fileList = this.handleUploadingFileList(uploadProcedureFileNum, uploadSupportingFileNum);

    const currentPageType = pageType !== undefined ? pageType : "createProcedure";

    return (
      <NormalSpin
        spinning={loading}
        size="large"
        indicator={
          uploadingFileNum > 0 ? (
            <p className="loadingText">
              Uploading {uploadingFileNum}/{fileList.length} file
            </p>
          ) : this.state.fileLoading.allNum > 0 ? (
            <p className="loadingText">
              Uploading {this.state.fileLoading.currentNum}/{this.state.fileLoading.allNum} file
            </p>
          ) : undefined
        }
      >
        <div className={styles.body}>
          <div className={styles.header}>
            <div className={styles.headerTitleDiv}>
              <div className={styles.title}>{title ? title : "Create Procedure Detail"}</div>
              {isMounted && <StatusDiv status={status}></StatusDiv>}
            </div>
          </div>
          <ProcedureBlock
            child={<TaskInformation data={taskInformationData} />}
            isShowArrow={false}
            className="processProcedureBlock"
            isOpen={true}
          />
          {/* @ts-ignore */}
          <ProcedureFileSection
            ref={procedureRef}
            isMounted={isMounted}
            isShowTable={isShowTable}
            hintMsg={hintMsg}
            procedureId={procedureId}
            procedureTaskId={procedureTaskId}
            procedureAccountId={procedureAccountId}
            openSection={openSection}
            showLoading={this._showLoading}
            hideLoading={this._hideLoading}
            actionType="ProcedureFile"
            setActionType={this.setActionType}
            setIsProcedureFileModalChange={this.setIsProcedureFileModalChange}
            procedureSubmitSuccess={this._procedureSubmitSuccess}
            procedureSaveSuccess={this._procedureSaveSuccess}
            setLock={this.setLock}
            handleUploadLoading={this.handleProcedureFileUploadLoading}
            setUploadFileNum={this.setUploadProcedureFileNum}
            setFileNum={this.setProcedureFileNum}
            pageType={currentPageType}
            procedureStatus={status}
            isHighlyRequlatedTask={taskInformationData.highRegulated}
            procedureAccountID={taskInformationData.procedureAccountID}
            updateFileNumLoading={this.updateFileNumLoading}
            taskInformationData={taskInformationData}
            isShowProcedureFileEdit={sectionEditShow.isShowProcedureFileEdit}
          />
          {/* @ts-ignore */}
          <SupportingFileSection
            ref={supportingRef}
            isMounted={isMounted}
            isShowTable={isShowTable}
            hintMsg={hintMsg}
            procedureId={procedureId}
            procedureTaskId={procedureTaskId}
            procedureAccountId={procedureAccountId}
            showLoading={this._showLoading}
            hideLoading={this._hideLoading}
            actionType="SupportingFile"
            setActionType={this.setActionType}
            setIsSupportingFileModalChange={this.setIsSupportingFileModalChange}
            submitSuccess={this._supportingSubmitSuccess}
            saveSuccess={this._supportingSaveSuccess}
            setLock={this.setLock}
            handleUploadLoading={this.handleSupportingFileUploadLoading}
            setUploadFileNum={this.setUploadSupportingFileNum}
            setFileNum={this.setSupportingFileNum}
            pageType={currentPageType}
            taskInformationData={taskInformationData}
            isShowSupportingFileEdit={sectionEditShow.isShowSupportingFileEdit}
          />
          {/* @ts-ignore */}
          <ProcedureInfoSection
            ref={procedureInfoRef}
            isMounted={isMounted}
            hintMsg={hintMsg}
            procedureId={procedureId}
            procedureTaskId={procedureTaskId}
            procedureAccountId={procedureAccountId}
            setLock={this.setLock}
            showLoading={this._showLoading}
            hideLoading={this._hideLoading}
            actionType="ProcedureInfo"
            setActionType={this.setActionType}
            setIsProcedureInfoModalChange={this.setIsProcedureInfoModalChange}
            procedureInfoSubmitSuccess={this._procedureInfoSubmitSuccess}
            setProcedureJbStatusId={this.setProcedureJbStatusId}
            isShowProcedureInfoEdit={sectionEditShow.isShowProcedureInfoEdit}
          />
          {/* @ts-ignore */}
          <ProcedureBlock
            child={this.handleReturnShareTask("Shared Tasks")}
            isShowArrow={false}
            className="processProcedureBlock"
            isOpen={true}
          />
        </div>
      </NormalSpin>
    );
  }
}

export default withRouter(CreateProcedureDetail);
